import type { UserPermissionKeyType, UserPermissionType } from './types';

// Mirrors Gasbi.Distribution.Households.Billing.Contracts.Constants.HouseholdsPermissions (GSB-8308). The API returns
// the names lowercased.
export const UserPermissions = {
  // 1 Особові рахунки
  PersonalAccountsPersonalAccountRead: 'personalaccounts.personalaccount.read',
  PersonalAccountsPersonalAccountManage:
    'personalaccounts.personalaccount.manage',
  PersonalAccountsGeneralInformationRead:
    'personalaccounts.generalinformation.read',
  PersonalAccountsGeneralInformationManage:
    'personalaccounts.generalinformation.manage',
  PersonalAccountsMeteringNodeRead: 'personalaccounts.meteringnode.read',
  PersonalAccountsMeteringNodeManage: 'personalaccounts.meteringnode.manage',
  PersonalAccountsConsumptionRead: 'personalaccounts.consumption.read',
  PersonalAccountsConsumptionManage: 'personalaccounts.consumption.manage',
  PersonalAccountsMeterReadingsRead: 'personalaccounts.meterreadings.read',
  PersonalAccountsMeterReadingsManage: 'personalaccounts.meterreadings.manage',
  PersonalAccountsDocumentsAndFilesRead:
    'personalaccounts.documentsandfiles.read',
  PersonalAccountsDocumentsAndFilesManage:
    'personalaccounts.documentsandfiles.manage',
  PersonalAccountsActsRead: 'personalaccounts.acts.read',
  PersonalAccountsActsManage: 'personalaccounts.acts.manage',

  // 2 Будинкові профілі
  BuildingProfilesBuildingProfileRead: 'buildingprofiles.buildingprofile.read',
  BuildingProfilesBuildingProfileManage:
    'buildingprofiles.buildingprofile.manage',
  BuildingProfilesGeneralInformationRead:
    'buildingprofiles.generalinformation.read',
  BuildingProfilesGeneralInformationManage:
    'buildingprofiles.generalinformation.manage',
  BuildingProfilesSubscribersRead: 'buildingprofiles.subscribers.read',
  BuildingProfilesSubscribersManage: 'buildingprofiles.subscribers.manage',
  BuildingProfilesMeteringNodeRead: 'buildingprofiles.meteringnode.read',
  BuildingProfilesMeteringNodeManage: 'buildingprofiles.meteringnode.manage',
  // «Покази будинку»
  BuildingProfilesConsumptionRead: 'buildingprofiles.consumption.read',
  BuildingProfilesConsumptionManage: 'buildingprofiles.consumption.manage',
  BuildingProfilesActsRead: 'buildingprofiles.acts.read',
  BuildingProfilesActsManage: 'buildingprofiles.acts.manage',
  BuildingProfilesDocumentsAndFilesRead:
    'buildingprofiles.documentsandfiles.read',
  BuildingProfilesDocumentsAndFilesManage:
    'buildingprofiles.documentsandfiles.manage',

  // 3 Нерозподілені показання
  MeterReadingsUnallocatedMeterReadingsRead:
    'meterreadings.unallocatedmeterreadings.read',
  MeterReadingsUnallocatedMeterReadingsManage:
    'meterreadings.unallocatedmeterreadings.manage',

  // 4 Оперативне споживання
  OperationalAccountingOperationalConsumptionRead:
    'operationalaccounting.operationalconsumption.read',
  // Вивантаження Форми 2
  OperationalAccountingForm2ExportManage:
    'operationalaccounting.form2export.manage',

  // 5 Фактичний облік
  ActualAccountingActualConsumptionRead:
    'actualaccounting.actualconsumption.read',
  ActualAccountingActualConsumptionManage:
    'actualaccounting.actualconsumption.manage',
  ActualAccountingDataCorrectionRead: 'actualaccounting.datacorrection.read',
  ActualAccountingDataCorrectionManage:
    'actualaccounting.datacorrection.manage',
  ActualAccountingOrderedCapacityRead: 'actualaccounting.orderedcapacity.read',
  ActualAccountingOrderedCapacityManage:
    'actualaccounting.orderedcapacity.manage',

  // 6 Фінанси (the Finance UI's pages, GSB-8373)
  FinanceAccountsRead: 'finance.accounts.read',
  FinanceAccountsManage: 'finance.accounts.manage',
  FinanceUndistributedPaymentsRead: 'finance.undistributedpayments.read',
  FinanceUndistributedPaymentsManage: 'finance.undistributedpayments.manage',

  // 7 Організації: the shared Permissions.Organizations, which the shared organization page (RbacOrganization) reads
  // from userPermissions. Households grants Organization and Employee only; the rest are Distribution Admin's.
  OrganizationsOrganizationRead: 'organizations.organization.read',
  OrganizationsOrganizationManage: 'organizations.organization.manage',
  OrganizationsMainOrganizationManage: 'organizations.mainorganization.manage',
  OrganizationsStructuralSubdivisionManage:
    'organizations.structuralsubdivision.manage',
  OrganizationsEmployeeRead: 'organizations.employee.read',
  OrganizationsEmployeeManage: 'organizations.employee.manage',
  OrganizationsRoleAndPermissionRead: 'organizations.roleandpermission.read',
  OrganizationsRoleAndPermissionManage:
    'organizations.roleandpermission.manage',
} as const satisfies Partial<Record<UserPermissionKeyType, UserPermissionType>>;
